var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCCause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 467,
    viewBox: "0 0 465 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.965 246.172V425.63L423.775 467H41.1896L0 425.63V41.3699L41.1896 0H423.775L464.965 41.3699V220.828H245.099V116.768C245.099 113.202 243.869 110.096 241.444 107.414C239.019 104.731 236.032 103.637 232.482 104.095C228.933 104.095 225.946 105.437 223.521 108.084C221.096 110.767 219.865 113.873 219.865 117.438V349.597C219.865 353.162 220.744 356.162 222.536 358.598C224.294 361.034 226.965 362.481 230.514 362.94C234.486 363.822 237.93 362.94 240.812 360.257C243.694 357.574 245.135 354.256 245.135 350.268V246.207H465L464.965 246.172Z",
    fill: "#FEFEE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCCause);
export default __webpack_public_path__ + "static/media/C-Cause.6151064f6e1ce8bfce974987c3148ba7.svg";
export { ForwardRef as ReactComponent };